"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePagination = usePagination;
var _react = require("react");
/**
 * A hook that handles pagination.
 * @param data - The data array to paginate.
 * @param {Object} options
 * @param {number} [options.itemsPerPage] - Number of items per page. Returns all items if no value has been provided.
 * @param {number} [options.initialPage=1] - Initial page number. Defaults to 1.
 * @param {boolean} [options.autoResetPage=false] - Whether to reset the page number to 1 when the data changes.
 */

function usePagination(data, options) {
  var _data$length;
  const defaultOptions = {
    initialPage: 1,
    autoResetPage: false
  };
  const {
    itemsPerPage,
    initialPage,
    autoResetPage
  } = Object.assign(defaultOptions, options);
  const totalItems = (_data$length = data === null || data === void 0 ? void 0 : data.length) !== null && _data$length !== void 0 ? _data$length : 0;
  const initialPageIndex = initialPage > 0 ? initialPage - 1 : 0;
  const [pageIndex, setPageIndex] = (0, _react.useState)(initialPageIndex);
  const startIndex = typeof itemsPerPage === "number" ? pageIndex * itemsPerPage : 0;
  const paginate = pageNumber => setPageIndex(pageNumber - 1);
  (0, _react.useEffect)(() => {
    if (typeof itemsPerPage === "number" && startIndex >= totalItems) {
      !autoResetPage && Math.floor(totalItems / itemsPerPage) > 0 ?
      // go to the last available page if the current page is out of bounds
      setPageIndex(Math.floor(totalItems / itemsPerPage) - 1) :
      // go to the initial page if autoResetPage is true
      setPageIndex(0);
    }
  }, [pageIndex, startIndex, setPageIndex, totalItems, itemsPerPage, autoResetPage]);
  const pageData = (0, _react.useMemo)(() => typeof itemsPerPage === "number" ? data === null || data === void 0 ? void 0 : data.slice(startIndex, startIndex + itemsPerPage) : data, [startIndex, data, itemsPerPage]);
  return {
    pageData,
    currentPage: pageIndex + 1,
    paginate,
    itemsPerPage,
    totalItems
  };
}